export default "__VITE_PUBLIC_ASSET__a7907592__"